import DepartmentConfig from './index.vue';

export default [
  {
    path: '/department-config',
    name: 'DepartmentConfig',
    component: DepartmentConfig,
    meta: {
      title: '参数设置',
    },
  },
];



// WEBPACK FOOTER //
// ./src/views/DepartmentConfig/index.js